import ModifierComboGroupButton from "./ModifierComboGroupButton";
// Returns a group container that holds a group button inside a modifier combo

export default function ModifierComboGroupContainer(props) {

    return (
        <>
            <div className="col-12 wo-opt__head">
                <span className="wo-opt__name">{props.modifierComboGroupDetails.modCategoryName}</span>
            </div>
            <div className="col-12">
                <ModifierComboGroupButton
                    key={props.modComboGroupIndex}
                    modComboGroupIndex={props.modComboGroupIndex}
                    modComboGroupFormData={props.modComboGroupFormData}
                    modifierComboGroupDetails={props.modifierComboGroupDetails}
                    handleModifierComboGroupSelect={props.handleModifierComboGroupSelect}
                />
            </div>
        </>
    )
}